import { HOME_META, SITE_URL } from '@/data/marketingContent';

export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const SOFTWARE_ID = `${SITE_URL}/#software`;

/** Date the marketing pages were last reviewed for accuracy. Update when content is re-checked. */
export const CONTENT_REVIEWED = '2026-09-18';
export const CONTENT_REVIEWED_LABEL = '18 September 2026';

export const FOUNDERS = [
  { '@type': 'Person', '@id': `${SITE_URL}/about#amine-boukioud`, name: 'Amine BOUKIOUD', jobTitle: 'Co-Founder', worksFor: { '@id': ORG_ID } },
  { '@type': 'Person', '@id': `${SITE_URL}/about#mustapha-boukioud`, name: 'Mustapha BOUKIOUD', jobTitle: 'Co-Founder', worksFor: { '@id': ORG_ID } },
];

export const ORGANIZATION = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': ORG_ID,
  name: 'Beatview',
  url: SITE_URL,
  logo: { '@type': 'ImageObject', url: `${SITE_URL}/beatview-logo.svg` },
  image: `${SITE_URL}/og-image.png`,
  description: 'Beatview builds the AI recruiting agent for recruitment agencies: it screens every application, runs structured AI video interviews and prepares evidence-backed shortlists, while recruiters make every hiring decision.',
  foundingDate: '2024',
  founder: FOUNDERS,
  slogan: 'The agent screens. Your recruiters decide.',
  knowsAbout: ['AI recruiting agents', 'Recruitment agency software', 'AI resume screening', 'Structured one-way video interviews', 'Recruitment automation', 'Candidate evidence and explainable scoring'],
  email: 'contact@beatview.ai',
  contactPoint: [
    { '@type': 'ContactPoint', contactType: 'sales', email: 'contact@beatview.ai', availableLanguage: ['English', 'French', 'Portuguese', 'Spanish'] },
    { '@type': 'ContactPoint', contactType: 'customer support', email: 'support@beatview.ai' },
    { '@type': 'ContactPoint', contactType: 'security', email: 'security@beatview.ai' },
  ],
  sameAs: ['https://www.linkedin.com/company/beatview'],
};

export const WEBSITE = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  name: 'Beatview',
  url: SITE_URL,
  description: HOME_META.description,
  inLanguage: 'en',
  publisher: { '@id': ORG_ID },
};

/** Compact publisher reference usable on any page. */
export const PUBLISHER = { '@type': 'Organization', '@id': ORG_ID, name: 'Beatview', url: SITE_URL, logo: { '@type': 'ImageObject', url: `${SITE_URL}/beatview-logo.svg` } };
